import type { DialogConfig } from '#types/config/components/dialog'
import type { RecursivePartial } from '#types/utils'

export default {
  closeButtonSize: 'sm',
  showCloseButton: true
} satisfies RecursivePartial<DialogConfig['productDetailCard']>
